import { Box } from "@mui/material";
import type { FC } from "react";
import { GraphsSelector } from "./Header/GraphsSelector";
import { ReportMenu } from "./Header/ReportMenu";
import { ReportSchedule } from "./Header/ReportSchedule";
import type { ManagementCenterChartKey } from "./utlis";

type Props = {
	visibleCharts: ManagementCenterChartKey[];
	onVisibleChartsChange: (visible: ManagementCenterChartKey[]) => void;
};

export const ManagementCenterMultiSettings: FC<Props> = ({ visibleCharts, onVisibleChartsChange }) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
			}}
		>
			<GraphsSelector visibleCharts={visibleCharts} onVisibleChartsChange={onVisibleChartsChange} />
			<ReportMenu />
			<ReportSchedule />
		</Box>
	);
};
